class Contact {
    constructor() {
        this.subject = document.getElementsByName('subject')[0];
        this.reason = document.querySelector('.contact__reason');

        if(this.subject) {
            this.ask_reasons = JSON.parse(this.subject.dataset.askReason);

            this.subject.onchange = () => this.subjectChange();
            this.subjectChange();
        }
    }

    subjectChange() {
        let numeric_value = Number(this.subject.value);

        if(!isNaN(numeric_value) && this.ask_reasons.indexOf(numeric_value) !== -1) {
            this.reason.style.display = 'block';
        }
        else {
            this.reason.style.display = 'none';
        }
    }
}

new Contact();



// WEBPACK FOOTER //
// ./src/my_artis/js/views/contact.js